import {SubmitHandler, UseFormReturn} from 'react-hook-form'
import {BulkOrderFormValues} from '../../../BulkOrdersFormValues'
import {isEmpty} from 'lodash'
import {
  OrderIntakeOption,
  OrderRequest,
  OrderRequestGroupResponse
} from '../../../declarations/types'
import {submitOrders} from '../../handlers/submitOrders'
import {trackSubmissionAnalytics} from '../../handlers/trackSubmissionAnalytics'
import {LoadType} from '../../../../App.constants'
import {ShippingType} from '../../../declarations/OrderIntake.enums'

interface UseCollectSubmitParams {
  methods: UseFormReturn<BulkOrderFormValues>
  materialEditorController: {activeMaterialForm?: unknown}
  hasSiteContactNameAndPhone: boolean
  setCollections: (collections: OrderRequest[]) => void
  setPlaceOrderStatus: (status: boolean) => void
  shouldUseV2: boolean
  selectedSite: OrderIntakeOption
  userProfileCountry: string | undefined
  businessLineCode: string
  defaultBusinessLine: string
  userPrimaryOrganisationalUnit: string | undefined
  mutateAsyncV1: (params: {orderIntakePayload: any}) => Promise<any>
  mutateAsyncV2: (params: {orderIntakePayload: any}) => Promise<any>
  setOrderSummaryDataArray: (dataArray: OrderRequestGroupResponse[]) => void
  setOrderSummary: (summary: any) => void
  setShowConfirmationStatusScreen: (show: boolean) => void
  quantityType: string
  orderIntakeCustomerReferenceField: boolean
  orders: OrderRequest[]
  language: string
  orderSessionEventId: string | undefined
}

export const useCollectSubmit = (params: UseCollectSubmitParams) => {
  const {
    methods,
    materialEditorController,
    hasSiteContactNameAndPhone,
    setCollections,
    setPlaceOrderStatus,
    shouldUseV2,
    selectedSite,
    userProfileCountry,
    businessLineCode,
    userPrimaryOrganisationalUnit,
    mutateAsyncV1,
    mutateAsyncV2,
    setOrderSummaryDataArray,
    setOrderSummary,
    setShowConfirmationStatusScreen,
    quantityType,
    defaultBusinessLine,
    orderIntakeCustomerReferenceField,
    orders,
    language,
    orderSessionEventId
  } = params

  const onSubmit: SubmitHandler<BulkOrderFormValues> = (data) => {
    if (materialEditorController.activeMaterialForm) return

    const updatedCollections = data.orders.map((collection) => ({
      ...collection,
      payload: {
        ...collection.payload,
        isSendingConfirmationEmailUnChecked: !data.isConfirmationMailChecked,
        contact: {
          ...data.contact,
          siteContactName:
            isEmpty(data.contact?.siteContactName) && hasSiteContactNameAndPhone
              ? data.contact?.fullName
              : data.contact?.siteContactName,
          backupPhone:
            isEmpty(data.contact?.backupPhone) && hasSiteContactNameAndPhone
              ? data.contact?.mainPhone
              : data.contact?.backupPhone
        }
      }
    }))

    methods.setValue('isOrderRequestConfirmed', false)
    setCollections(updatedCollections as OrderRequest[])
    setPlaceOrderStatus(true)

    submitOrders({
      updatedDeliveries: updatedCollections,
      shouldUseV2,
      selectedSite,
      userProfileCountry,
      businessLineCode,
      userPrimaryOrganisationalUnit,
      mutateAsyncV1,
      mutateAsyncV2,
      isAutoConfirmed: false,
      isConfigurableSlots: false,
      setOrderSummaryDataArray,
      setOrderSummary,
      setPlaceOrderStatus,
      setShowConfirmationStatusScreen
    })

    trackSubmissionAnalytics({
      quantityType,
      updatedDeliveries: updatedCollections,
      data,
      defaultBusinessLine,
      orderIntakeCustomerReferenceField,
      orders,
      orderSessionEventId: orderSessionEventId ?? '',
      language,
      loadType: LoadType.NonSplit,
      shippingType: ShippingType.COLLECT,
      trackAlternativePhone: false
    })
  }

  return {onSubmit}
}
